<span mat-icon-button class="search-wrapper alignRow" style="margin-left: var(--default-margin);margin-right: var(--default-margin);">
  <span *ngIf="Caption" style="font-weight: bold;">{{Caption}}&nbsp;</span>
  <span *ngIf="searchValue">Filtered&nbsp;</span>
  <mat-icon (click)="toggleSearch()" [ngClass]="{ 'active-filter': !!searchValue }" style="margin-left: 0px;">search</mat-icon>
  <div class="search-container" [class.visible]="searchVisible">
    <div class="input-wrapper alignRow">
      <input class="custom-input" autocomplete="off" [placeholder]="PlaceHolder" type="text" [(ngModel)]="searchValue"
        (keyup)="onSearch($event)" />
      <mat-icon *ngIf="searchValue" (click)="clearSearch()" aria-label="Clear search input">close</mat-icon>
    </div>
  </div>
</span>
